import React from "react";

const ProfileDetails = ({ profile, setProfile, username, countries, token }) => {
  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/users/me/profile/avatar`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });

    if (res.ok) {
      const data = await res.json();
      setProfile({ ...profile, avatar_url: data.avatar_url });
    } else {
      alert("Failed to upload avatar");
    }
  };

  return (
    <>
      {/* Avatar */}
      <div>
        <label className="block font-semibold text-accent mb-2">Avatar</label>
        {profile.avatar_url ? (
          <img
            src={
              profile.avatar_url.startsWith("http")
                ? profile.avatar_url
                : `${process.env.REACT_APP_API_URL}${profile.avatar_url}`
            }
            alt="Avatar"
            className="w-24 h-24 rounded-full object-cover"
          />
        ) : (
          <p className="text-sm text-gray-500">No avatar uploaded</p>
        )}
        <input type="file" accept="image/*" onChange={handleAvatarUpload} />
      </div>

      {/* First Name & Last Name */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        <div>
          <label className="block font-semibold text-accent mb-2">First Name</label>
          <input
            type="text"
            value={profile.first_name || ""}
            onChange={(e) => setProfile({ ...profile, first_name: e.target.value })}
            className="text-sm sm:text-base p-2 sm:p-3"
            placeholder="Enter first name"
          />
        </div>
        <div>
          <label className="block font-semibold text-accent mb-2">Last Name</label>
          <input
            type="text"
            value={profile.last_name || ""}
            onChange={(e) => setProfile({ ...profile, last_name: e.target.value })}
            className="text-sm sm:text-base p-2 sm:p-3"
            placeholder="Enter last name"
          />
        </div>
      </div>

      {/* Language */}
      <div>
        <label className="block font-semibold text-accent mb-2">Language</label>
        <select
          value={profile.language || "en"}
          onChange={(e) => setProfile({ ...profile, language: e.target.value })}
          className="border rounded-md p-2 w-full"
        >
          <option value="en">English</option>
          <option value="zh">中文</option>
        </select>
      </div>

      {/* Location */}
      <div>
        <label className="block font-semibold text-accent mb-2">Location</label>
        <select
          value={profile.location || ""}
          onChange={(e) => setProfile({ ...profile, location: e.target.value })}
          className="border rounded-md p-2 w-full"
        >
          <option value="">Select Country</option>
          {countries.map((c) => (
            <option key={c.id} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default ProfileDetails;
